/// <reference path="input.ts" />

/**
 * <dl>
 * <dt>属性</dt>
 * </dl>
 * その他の属性はKoyoriInputに依存します。ただし、valueの挙動が違うので注意してください。
 */
class KoyoriCheckbox extends KoyoriInput {

	static get observedAttributes() {
		return ['label', 'message', 'indeterminate'].concat(this.inputAttributes);
	}

	static get inputAttributes() {
		return ['value', 'name', 'disabled', 'autocomplete', 'list', 'maxlength', 'pattern', 'placeholder', 'readonly', 'inputmode', 'checked', 'indeterminate'];
	}

	/** チェック状態を表示するエレメント */
	protected boxElement: HTMLElement;
	
	/** 最後の不定状態 */
	private lastIndeterminate = false;

	constructor() {
		super();
	}
	
	connectedCallback(): void {
		if (this.boxElement == undefined) {
			this.boxElement = <HTMLElement>this.querySelector('.koy-checkbox-box');
			if (this.boxElement == null) {
				let wrapper = this.inputElement.parentElement;
				wrapper.insertBefore(this.inputElement, this.labelElement);

				this.boxElement = document.createElement('span');
				this.boxElement.classList.add('koy-checkbox-box');
				this.boxElement.textContent = ' ';
				wrapper.insertBefore(this.boxElement, this.labelElement);
			}
			
			this.inputElement.addEventListener('change', (event) => {
				if (this.lastIndeterminate == false) {
					return;
				}
				this.checked = false;
				this.lastIndeterminate = false;
			});
		}
		
		super.connectedCallback();
	}

	/**
	 * @return チェック状態
	 */
	get checked(): boolean {
		return (<HTMLInputElement>this.inputElement).checked;
	}

	/**
	 * @param checked チェック状態
	 */
	set checked(checked: boolean) {
		(<HTMLInputElement>this.inputElement).checked = checked;
	}

	/**
	 * チェック状態ならvalue属性の値を返します。チェック状態でない場合はnullを返します。value属性が存在しない場合は'true'もしくは'false'を返します。
	 * 
	 * @return 設定されている値
	 */
	get value(): string {
		if (this.inputElement.getAttribute('value') == null) {
			if (this.checked) {
				return 'true';
			} else {
				return 'false';
			}
		}
		if (this.checked == false) {
			return null;
		}
		return (<HTMLInputElement>this.inputElement).value;
	}

	/**
	 * 値がvalue属性の値と同じならチェック状態にします。
	 * 
	 * @param value 設定する値
	 */
	set value(value: string) {
		if ((<HTMLInputElement>this.inputElement).value == value) {
			this.checked = true;
		} else {
			this.checked = false;
		}
	}

	/**
	 * @return 不定状態
	 */
	get indeterminate(): boolean {
		return (<HTMLInputElement>this.inputElement).indeterminate;
	}

	/**
	 * @param checked 不定状態
	 */
	set indeterminate(indeterminate: boolean) {
		(<HTMLInputElement>this.inputElement).indeterminate = indeterminate;
	}
	
	indeterminateChanged(indeterminate: string) {
		this.lastIndeterminate = (indeterminate == null) ? false : true;
		if (indeterminate != null) {
			this.indeterminate = true;
		} else {
			this.indeterminate = false;
		}
	}

	/**
	 * @return inputタグのtype属性の値
	 */
	protected getInputType(): string {
		return 'checkbox';
	}

	/**
	 * @return 変更イベントを取得する属性のリスト
	 */
	protected getObservedAttributes(): string[] {
		return KoyoriCheckbox.observedAttributes;
	}

	/**
	 * @return inputタグに設定する属性のリスト
	 */
	protected getInputAttributes(): string[] {
		return KoyoriCheckbox.inputAttributes;
	}

	/**
	 * メッセージエレメントのスタイルを変更します。
	 */
	protected updateMessageElementStyle() {
		this.messageElement.style.width = (this.boxElement.offsetWidth + this.labelElement.offsetWidth) + 'px';
	}

}
window.customElements.define('koy-checkbox', KoyoriCheckbox);
